export enum Stages {
  DEFAULT = 'default',
  CHANGE_SOMETHING = 'change_something',
  HAVE_QUESTIONS = 'have_questions',
  CHANGE_WORDING_OR_DESCRIPTIONS = 'change_wording_or_descriptions',
  ASK_SOMETHING_ELSE = 'ask_something_else',
}

export enum Selections {
  CHANGE_SOMETHING = 'change_something',
  HAVE_QUESTIONS = 'have_questions',
  DEFAULT_ASK_SOMETHING_ELSE = 'default_ask_something_else',

  CUSTOMIZE_DRAFT_ITINERARY = 'customize_draft_itinerary',
  CHANGE_WORDING_OR_DESCRIPTIONS = 'change_wording_or_descriptions',
  CHANGE_DATES_GROUP_SIZE_MARKUP = 'change_dates_group_size_markup',
  CHANGE_SOMETHING_ELSE = 'change_something_else',

  DETAILS_OF_TRIP = 'details_of_trip',
  DETAILS_OF_CONTRACT = 'details_of_contract',
  TRAVELER_EXPERIENCES = 'traveler_experiences',
  HOW_PROCESS_WORKS = 'how_process_works',

  SOMETHING_DOESNT_MAKE_SENSE = 'something_doesnt_make_sense',
  HUMAN_SENSE_CHECK = 'human_sense_check',
  ASK_SOMETHING_ELSE = 'ask_something_else',

  CANCEL = 'cancel',
}

/** Selections allowed per stage. Use `never` where a stage has no selectable options. */
type StageToSelections = {
  [Stages.DEFAULT]: Selections.CHANGE_SOMETHING | Selections.HAVE_QUESTIONS | Selections.ASK_SOMETHING_ELSE
  [Stages.CHANGE_SOMETHING]:
    | Selections.CUSTOMIZE_DRAFT_ITINERARY
    | Selections.CHANGE_WORDING_OR_DESCRIPTIONS
    | Selections.CHANGE_DATES_GROUP_SIZE_MARKUP
    | Selections.CHANGE_SOMETHING_ELSE
  [Stages.HAVE_QUESTIONS]:
    | Selections.DETAILS_OF_TRIP
    | Selections.DETAILS_OF_CONTRACT
    | Selections.TRAVELER_EXPERIENCES
    | Selections.HOW_PROCESS_WORKS
    | Selections.ASK_SOMETHING_ELSE
  [Stages.ASK_SOMETHING_ELSE]:
    | Selections.SOMETHING_DOESNT_MAKE_SENSE
    | Selections.HUMAN_SENSE_CHECK
    | Selections.ASK_SOMETHING_ELSE
  [Stages.CHANGE_WORDING_OR_DESCRIPTIONS]: never
}

/** Union of selections valid for stage S. */
export type SelectionForStage<S extends Stages> = StageToSelections[S]
